<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Comunicados</span>
  <span class="toolbar-spacer"></span>
  <button
    mat-icon-button
    (click)="newCommunication()"
    matTooltip="Nuevo comunicado"
  >
    <mat-icon>add</mat-icon>
  </button>
</mat-toolbar>

<block-ui>
  <div class="comms-page">
    @if (communications.length === 0 && !loading) {
      <div class="empty-state">
        <mat-icon class="empty-state__icon">campaign</mat-icon>
        <p class="empty-state__text">No hay comunicados enviados todavía.</p>
        <button mat-flat-button color="primary" (click)="newCommunication()">
          <mat-icon>add</mat-icon> Nuevo comunicado
        </button>
      </div>
    }

    @if (communications.length > 0) {
      <div class="comms-header-actions">
        <button mat-flat-button color="primary" (click)="newCommunication()">
          <mat-icon>add</mat-icon> Nuevo comunicado
        </button>
      </div>

      <div class="comms-list">
        @for (comm of communications; track comm._id) {
          <mat-card
            class="comm-card"
            (click)="viewDetail(comm._id!)"
            tabindex="0"
            role="button"
          >
            <div class="comm-card__header">
              <span class="comm-card__subject">{{ comm.subject }}</span>
              <div class="comm-card__stats">
                <span class="stat-chip stat-chip--sent" matTooltip="Enviados">
                  <mat-icon>send</mat-icon>
                  {{ comm.stats.sentCount }} / {{ comm.stats.totalRecipients }}
                </span>
                <span
                  class="stat-chip stat-chip--opened"
                  matTooltip="Aperturas"
                >
                  <mat-icon>mark_email_read</mat-icon>
                  {{ comm.stats.openedCount }}
                </span>
                @if (comm.stats.errorCount > 0) {
                  <span class="stat-chip stat-chip--error" matTooltip="Errores">
                    <mat-icon>error_outline</mat-icon>
                    {{ comm.stats.errorCount }}
                  </span>
                }
              </div>
            </div>
            <div class="comm-card__footer">
              <span class="comm-card__date">{{
                comm.createdAt | date: "dd/MM/yyyy HH:mm"
              }}</span>
              <div class="comm-card__footer-actions">
                <button
                  mat-stroked-button
                  class="action-btn"
                  (click)="editCommunication(comm._id!, $event)"
                  matTooltip="Editar comunicado"
                >
                  <mat-icon>edit</mat-icon> Editar
                </button>
                <button
                  mat-stroked-button
                  color="primary"
                  class="action-btn"
                  (click)="sendCommunication(comm._id!, $event)"
                  matTooltip="Enviar a todos los usuarios"
                >
                  <mat-icon>send</mat-icon> Enviar
                </button>
                <button
                  mat-stroked-button
                  class="action-btn action-btn--whatsapp"
                  (click)="sendWhatsAppCommunication(comm._id!, $event)"
                  matTooltip="Enviar por WhatsApp a participantes con teléfono"
                >
                  <mat-icon>chat</mat-icon> WhatsApp
                </button>
                <button
                  mat-stroked-button
                  color="warn"
                  class="action-btn"
                  (click)="deleteCommunication(comm._id!, $event)"
                  matTooltip="Eliminar comunicado"
                >
                  <mat-icon>delete</mat-icon> Eliminar
                </button>
                <mat-icon class="comm-card__arrow">chevron_right</mat-icon>
              </div>
            </div>
          </mat-card>
        }
      </div>
    }
  </div>
</block-ui>
